export const saaSApiHandler = {
  getBillingCycleTypes: {
    method: "GET",
    path: () => `saas-system/billing-cycles`
  }
};